'use client'

import { useField } from 'formik'
import { ComponentProps } from 'react'

import { Input } from '@syconium/little-miss-figgy/dist/components/Input/Input'

export type FormInputProps = {
  name: string
  type: ComponentProps<typeof Input>['type']
  placeholder?: string
}

export const FormInput = ({ name, placeholder, ...rest }: FormInputProps) => {
  const [field, meta] = useField(name)
  const hasError = meta.error !== undefined && meta.error.length > 0
  const displayError = meta.touched && hasError

  return (
    <Input
      {...rest}
      id={name}
      name={name}
      onBlur={field.onBlur}
      onChange={field.onChange}
      value={field.value}
      isInvalid={displayError}
      messageWhenInvalid={meta.error}
      placeholder={placeholder}
    />
  )
}
